<template>
  <div id="app" v-images-loaded="loaded">
    <SunHeroHeader/>
    <main>
      <router-view/>
    </main>
    <SunHeroFooter/>
  </div>
</template>

<script>

import imagesLoaded from 'vue-images-loaded'
import SunHeroFooter from '@/components/main/SunHeroFooter.vue'
import SunHeroHeader from '@/components/main/SunHeroHeader.vue'
export default {
  components: {
    SunHeroHeader,
    SunHeroFooter
  },
  directives: {
    imagesLoaded
  },
  methods: {
    loaded () {
      setTimeout(() => {
        this.$store.commit('START_STICKY')
      }, 200)
    }
  }
}
</script>

<style lang="less">

  @import '~@/assets/css/reset.less';
  @import '~@/assets/css/grid-plus.css';
  @import '~@/assets/css/fonts.less';
  @import '~@/assets/css/variables.less';
  @import '~@/assets/css/global.less';

</style>
